import './style.css';
import React, { Fragment, useEffect, useRef, useState } from 'react'
import { http_request } from '../../../../libs/connection';
import { BASE_ROUTE, SESSION_EXPIRED_CODE } from '../../../../config';
import { createTimeString } from '../../../../libs/lib';
import { BsArrowReturnLeft } from 'react-icons/bs';
import Progress from '../../../../components/progress';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Button, Toast, ToastContainer } from 'react-bootstrap';

function PurchaseRejectDetail() {
    const MAX_COLUMNS = 6;
    const LINES_PER_ROW = 2;//每一个 row 有2行组成所以空白行也 * 2
    const url_params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const { pathname } = location;
    const { dl_no } = url_params;
    const [is_loading, setLoadingStatus] = useState(false);
    const [order, setOrder] = useState({});
    const [empty_rows, setEmptyRows] = useState([LINES_PER_ROW]);
    const [tablet_show, showTablet] = useState(false);
    const [success_toast_show, showSuccessToast] = useState(false);
    const [error_toast_show, showErrorToast] = useState(false);
    const [error_message, setErrorMessage] = useState('');
    const canvas_ref = useRef(0);
    var last_click_time = 0;
    var click = 0;
    var is_mouse_down = false;
    var stroke_width = 2;


    useEffect(()=>{
        loadOrder();
        initParams();
    }, [pathname, dl_no]);
    useEffect(()=>{
        if(tablet_show) initCanvas();
    }, [tablet_show]);

    function loadOrder(){
        if(!dl_no) return;
        let params = {
            dl_no
        };
        http_request('/purchaseRejectOrder/get', 'POST', params).then(res=>{
            if(res.success){
                let raw_data = res.data.purchase_reject_orders;
                if(raw_data.length === 0) return;
                let order = raw_data[0];
                order.detail = raw_data.filter(od=>od.flag !== 'D').map(row=>Object.assign({}, row));
                for(let i = 0 ; i < order.detail.length ; i++){
                    delete order.detail[i].detail;
                }
                let epr = 4 - order.detail.length;
                if(epr <= 0 ) epr = 1;
                epr *= LINES_PER_ROW;
                setEmptyRows((new Array(epr)).fill(1));
                setOrder(order);
            }else if(res.message === SESSION_EXPIRED_CODE){
                navigate(`${BASE_ROUTE}/logout`);
            }
        })
    }
    function initParams(){
        last_click_time = 0;
        click = 0;
        is_mouse_down = false;
    }
    function getCTX(){
        const canvas = canvas_ref.current;
        if(!canvas) return null;
        const ctx = canvas.getContext("2d");
        return ctx;
    }
    function initCanvas(){
        const ctx = getCTX();
        if(!ctx || !window) return;
        ctx.fillStyle = '#000';
        const canvas = canvas_ref.current;
        canvas.width = document.getElementById('canvas_container').clientWidth;
        canvas.height = document.getElementById('canvas_container').clientHeight;
        clearCanvas();
    }
    function mouse_down(e){
        const ctx = getCTX();
        if(!ctx) return;
        is_mouse_down = true;
        let pos = getMousePos(e);
        ctx.moveTo(pos.x, pos.y)
        ctx.beginPath();
        ctx.lineWidth  = stroke_width;
        ctx.lineCap = "round";
        ctx.strokeStyle = '#000';
    }
    function mouse_downT(e){
        mouse_down(e.nativeEvent.touches[0]);
    }
    function draw(e){
        if(!is_mouse_down) return;
        const ctx = getCTX();
        if(!ctx) return;
        let pos = getMousePos(e);
        ctx.lineTo(pos.x, pos.y)
        ctx.stroke();
    }
    function drawT(e){
        draw(e.nativeEvent.touches[0]);
    }
    function clearCanvas(){
        const canvas = canvas_ref.current;
        const ctx = getCTX();
        if(!ctx) return;
        ctx.fillStyle = '#FFF';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.fillStyle = '#000';
    }
    function getMousePos(evt) {
        if(!canvas_ref.current) return;
        var rect = canvas_ref.current.getBoundingClientRect();
        return {
            x: evt.clientX - rect.left,
            y: evt.clientY - rect.top
        };
    }
    function confirmOrder(){
        let params = { dl_no };
        http_request('/purchaseRejectOrder/confirm', 'POST', params).then(res=>{
            if(res.success){
                showSuccessToast(true);
            }else if(res.message === SESSION_EXPIRED_CODE){
                navigate(`${BASE_ROUTE}/logout`);
            }else{
                showErrorToast(true);
                setErrorMessage(res.message);
            }
        });
    }
    return (
        <div id="page-purchase-reject-detail" className='page'>
            <Progress show={is_loading} variant="primary" />
            <ToastContainer 
                position='middle-bottom'
                style={{ zIndex: 1056 }}
                >
                <Toast 
                    show={success_toast_show} 
                    onClose={()=>{ showSuccessToast(false); }}
                    delay={2000}
                    autohide
                    bg="success"
                    className='text-white'
                >
                    <Toast.Header>
                        <strong className="me-auto">确认完成</strong>
                    </Toast.Header>
                    <Toast.Body>拒收单确认完成</Toast.Body>
                </Toast>
                <Toast 
                    show={error_toast_show} 
                    onClose={()=>{ showErrorToast(false); }}
                    delay={3000}
                    autohide
                    bg="danger"
                    className='text-white'
                >
                    <Toast.Header>
                        <strong className="me-auto">确认失败</strong>
                    </Toast.Header>
                    <Toast.Body>{error_message}</Toast.Body>
                </Toast>
            </ToastContainer>
            <div className={`bg-white d-block content `}>
                <div className={`d-flex align-items-center justify-content-between py-3 px-2 container head-container`}>
                    <span className='text-secondary pe-5 d-flex align-items-center cursor-pointer' onClick={()=>{ navigate(-1) }}>
                        <BsArrowReturnLeft size={20} className='pe-2' />
                        <span>返回</span>
                    </span>
                    <Button
                        size="sm"
                        variant="success"
                        className='px-3'
                        onClick={()=>{ confirmOrder(); }}
                        disabled={!order || order.confirm_user_id}
                    >厂商确认</Button>
                </div>
                <div className={`overflow-auto table-container`}>
                    <table className={`border border-dark m-auto  dtable`}>
                        <thead>
                            <tr>
                                <th className='text-center' colSpan={4}>
                                    <h1>凹凸精密机械有限公司</h1>
                                    <h3>採购拒收处理单</h3>
                                </th>
                            </tr>
                        </thead>
                    </table>
                    <table className={`border border-top-0 border-dark m-auto  dtable`}>
                        <tbody className='underline text-center'>
                            <tr>
                                <td className='td-border border-top-0 fw-bold' colSpan={2}>单号</td>
                                <td className='td-border border-top-0'>{dl_no}</td>
                                <td className='td-border border-top-0 fw-bold'>单据日期</td>
                                <td className='td-border border-top-0' colSpan={4}>{order.dl_date}</td>
                                <td className='td-border border-top-0 fw-bold'>厂商电话</td>
                                <td className='td-border border-top-0' colSpan={2}>{order.cu_tel}</td>
                            </tr>
                            <tr>
                                <td className='td-border border-top-0 fw-bold' colSpan={2}>供应商</td>
                                <td className='td-border border-top-0' colSpan={6}>{order.cu_name}</td>
                                <td className='td-border border-top-0 fw-bold'>厂商传真</td>
                                <td className='td-border border-top-0' colSpan={2}>{order.cu_fax}</td>
                            </tr>
                            <tr className='underline fw-bold'>
                                <td className='td-border border-top-0'>項次</td>
                                <td className='td-border border-top-0' colSpan={2}>料号</td>
                                <td className='td-border border-top-0' colSpan={2}>品名</td>
                                <td className='td-border border-top-0'>数量</td>
                                <td className='td-border border-top-0'>单位</td>
                                <td className='td-border border-top-0'>不良原因</td>
                                <td className='td-border border-top-0' colSpan={2}>采购单号</td>
                                <td className='td-border border-top-0'>送货单号</td>
                            </tr>
                            {
                                (order.detail || []).map((row, r)=><tr key={r}>
                                    <td className='td-border border-top-0'>{r + 1}</td>
                                    <td className='td-border border-top-0' colSpan={2}>{row.el_no}</td>
                                    <td className='td-border border-top-0' colSpan={2}>{row.el_name1}</td>
                                    <td className='td-border border-top-0'>{row.deal_qty2}</td>
                                    <td className='td-border border-top-0'>{row.unit}</td>
                                    <td className='td-border border-top-0 text-wrap'>{row.bd_name}</td>
                                    <td className='td-border border-top-0' colSpan={2}>{row.ch_no}</td>
                                    <td className='td-border border-top-0'>{row.fd_no}</td>
                                </tr>)
                            }
                            {
                                empty_rows.map((row, r)=><tr key={r}><td colSpan={MAX_COLUMNS}>　</td></tr>)
                            }
                        </tbody>
                    </table>
                    <table className={`border border-top-0 border-dark m-auto  dtable`}>
                        <tbody>
                            <tr>
                                <td>{order.ar_relna}</td>
                            </tr>
                            <tr>
                                <td>{order.ar_asgna}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default PurchaseRejectDetail;
